/**
 * @file The refusal a row model returns when its answer holds a row it
 * cannot read: a failed answer naming the query. Consumers: the Projects,
 * Pipeline, Orders and Invoicing models. One malformed row fails the whole
 * model, so no table or chart is ever drawn half-read.
 */
import type { NamedQueryId } from '#types';

import type { AnalyticsUnansweredFigure } from './index.types';

export const analyticsMalformedAnswer = (
  query: NamedQueryId,
): Extract<AnalyticsUnansweredFigure, { status: 'refused' }> => ({
  status: 'refused',
  answer: {
    status: 'failed',
    message: `The ${query} answer holds a malformed row.`,
  },
});
